import React, { memo } from 'react';
import { Slot } from '@radix-ui/react-slot';
import { ButtonProps } from './Button.types';
import { cn } from '../../../utils/cn';
import { baseStyles, variantStyles, sizeStyles } from './Button.styles';

export const Button = memo<
  ButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement>
>(({
  variant = 'primary',
  text,
  className,
  size = 'default',
  asChild = false,
  children,
  ...rest
}) => {
  const Comp = asChild ? Slot : 'button';
  const content = asChild ? children : (
    <span className="whitespace-[inherit]">{text}</span>
  );
  return (
    <Comp
      className={cn(
        baseStyles,
        variantStyles[variant],
        sizeStyles[size],
        className,
      )}
      {...rest}
    >
      {content}
    </Comp>
  );
});

Button.displayName = 'Button';
